var LoginMode;
(function (LoginMode) {
    LoginMode["COMPACT"] = "compact";
    LoginMode["FULLSCREEN"] = "fullscreen";
})(LoginMode || (LoginMode = {}));
var LoginTopMode;
(function (LoginTopMode) {
    LoginTopMode["LOGO"] = "logo";
    LoginTopMode["TEXT"] = "text";
})(LoginTopMode || (LoginTopMode = {}));
var LoginSlots;
(function (LoginSlots) {
    LoginSlots["PRIMARY"] = "custom";
    LoginSlots["SECONDARY"] = "secondary-content";
})(LoginSlots || (LoginSlots = {}));
export { LoginMode, LoginSlots, LoginTopMode, };
//# sourceMappingURL=login-constants.js.map